"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const NotificationsProgrammeesTable_1 = __importDefault(require("../Tables/NotificationsProgrammeesTable"));
const io_1 = require("react-icons/io");
const categorie_api_1 = require("../../../../utils/api/categorie/categorie.api");
const DateRangePickerFr_1 = __importDefault(require("../../../Shared/DateRangePickerFr"));
const NotificationsProgrammees = () => {
    var _a, _b;
    const [search, setSearch] = (0, react_1.useState)("");
    const [selectedCategory, setSelectedCategory] = (0, react_1.useState)("");
    const [dates, setDates] = (0, react_1.useState)({
        startDate: null,
        endDate: null,
        key: "selection",
    });
    const { data = { data: [], count: 0 }, isLoading: isLoadCategorie } = (0, categorie_api_1.useCategorieByTypeQuery)("notification");
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "pb-4 search-group-wrapper" },
            react_1.default.createElement("div", { className: "search-form-group position-relative" },
                react_1.default.createElement("span", { className: "search-input-icon" },
                    react_1.default.createElement(io_1.IoMdSearch, null)),
                react_1.default.createElement("input", { type: "search", className: "form-control search-form-control", id: "search", "aria-label": "UsernSearchame", placeholder: "Rechercher...", value: search, onChange: (e) => setSearch(e.target.value) })),
            react_1.default.createElement("div", { className: "select-form-group position-relative" },
                react_1.default.createElement("select", { value: selectedCategory, onChange: (e) => setSelectedCategory(e.target.value) },
                    react_1.default.createElement("option", { value: "" }, "Type de publication"),
                    !!(data === null || data === void 0 ? void 0 : data.data) && ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.length) > 0
                        ? (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.map((cat) => (react_1.default.createElement("option", { value: cat === null || cat === void 0 ? void 0 : cat.name, key: cat === null || cat === void 0 ? void 0 : cat.id }, cat === null || cat === void 0 ? void 0 : cat.name)))
                        : null)),
            react_1.default.createElement("div", { className: "select-form-group position-relative custom" },
                react_1.default.createElement(DateRangePickerFr_1.default, { value: dates, onChange: (range) => setDates(range), onClear: () => setDates({
                        startDate: null,
                        endDate: null,
                        key: "selection",
                    }) }))),
        react_1.default.createElement("div", { className: "table--wrapper admin-table--wrapper" },
            react_1.default.createElement(NotificationsProgrammeesTable_1.default, { search: search, selectedCategory: selectedCategory, dates: dates }))));
};
exports.default = NotificationsProgrammees;
